export default "__VITE_ASSET__1ecc2690__"